exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inline-title[data-v-20f11fbc],\nh4.box-title a[data-v-20f11fbc] {\n  display: inline-block;\n  font-weight: 700;\n  font-size: 16px;\n}\nh4.box-title a[data-v-20f11fbc] {\n  color: #005b97;\n}\n.inline-title[data-v-20f11fbc] {\n  color: #333;\n}\n", ""]);

// exports
